import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {},
    components: {
        ChangeView: {
            component: 'Card',
            title: '置换商品订单',
            content: {
                component: 'SknSubstitution',
            },
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/trade',
                    breadcrumbName: '交易管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/changeSku',
                            component: 'Viewport',
                            breadcrumbName: '订单置换skn',
                            childRoutes: [
                                {
                                    path: '/add/:id',
                                    component: 'SknsubstitutionAdd',
                                    breadcrumbName: '新增置换商品订单',
                                },
                                {
                                    path: '/add',
                                    component: 'SknsubstitutionAdd',
                                    breadcrumbName: '新增置换商品订单',
                                },
                                {
                                    path: '/detail/:id',
                                    component: 'SknsubstitutionDetail',
                                    breadcrumbName: '置换商品订单详情',
                                },
                                {
                                    path: '/',
                                    component: 'ChangeView',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};
